"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

export function CookiebotScript() {
  const pathname = usePathname();

  if (pathname?.startsWith("/lead")) return null;

  return (
    <Script
      src="https://consent.cookiebot.com/uc.js"
      id="Cookiebot"
      strategy="afterInteractive"
      data-cbid={process.env.NEXT_PUBLIC_COOKIEBOT_ID}
      data-blockingmode="auto"
      data-culture="de"
    />
  );
}
